import {Visitable} from './Visitable';
import {Visitor} from './Visitor';
import dayjs from "dayjs";

export interface Link {
    name: string;
    href: string;
}

export interface EventProps {
    registrar: string;
    server: string;
    status: string;
    testDate: dayjs.Dayjs;
    type: string;
    version: string;
    _links: any;
}
export default class Event implements Visitable {
    private _registrar: string;
    private _server: string;
    private _testDate: dayjs.Dayjs;
    private _type: string;
    private _version: string;
    private _status: string;
    private _linksLocal: any;

    constructor(event: EventProps) {
        this._registrar = event.registrar;
        this._server = event.server;
        this._type = event.type;
        this._version = event.version;
        this._testDate = dayjs(event.testDate);
        this._status = event.status;
        this._linksLocal = event._links;
    }

    public get type(): string {
        return this._type;
    }

    public get registrar(): string {
        return this._registrar;
    }

    public get version(): string {
        return this._version;
    }

    public get testDate(): dayjs.Dayjs {
        return this._testDate;
    }

    public get server(): string {
        return this._server;
    }

    public get status(): string {
        return this._status;
    }

    public get links(): any {
        return this._linksLocal;
    }

    public accept(visitor: Visitor): void {
        visitor.visitEvent(this);
    }
}